var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.serviceFeeList.length),expression:"serviceFeeList.length"}]},[_c('h4',{staticClass:"workplatform-title m-t-10 m-b-20"},[_vm._v("服务项概览")]),_c('Table',{attrs:{"stripe":"","size":"small","data":_vm.serviceFeeList,"columns":_vm.serviceFeeColumns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }